
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Onethreeurbaniaonrentinpune() {



    const cardData =
    {
        keyword: '13 Seater Urbania On Rent in Pune ',
        heading: 'Amruta Travels: 13 Seater Urbania On Rent in Pune ',
        headingDescription: 'Amruta Travels offers 13 Seater Urbania On Rent in Pune, providing a comfortable and reliable solution for group travel, including family outings, corporate trips, airport transfers, school excursions, and weekend getaways. Our 13-seater Force Urbania vans come with spacious interiors, air-conditioning, and modern amenities for a smooth and enjoyable journey. With experienced drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels ensures your 13-seater Urbania rental in Pune is safe, convenient, and stylish.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "13 Seater Urbania on rent in Pune",
    "description": "Book a 13 Seater Urbania on rent in Pune for family trips, corporate travel, airport transfers, city tours, and weekend getaways. Enjoy spacious seating, air-conditioned comfort, smooth rides, ample luggage space, and professional drivers for safe and reliable travel."
  },
  {
    "name": "Urbania 13 seater on rent Pune",
    "description": "Urbania 13 seater on rent in Pune ideal for local sightseeing, group travel, corporate transport, and long-distance trips. Luxury interiors, AC comfort, cushioned seats, and experienced drivers ensure a seamless travel experience."
  },
  {
    "name": "Force Urbania 13 seater on rent Pune",
    "description": "Force Urbania 13 seater on rent in Pune for families, corporate teams, and group outings. Offers spacious seating, air-conditioning, smooth ride, and professional drivers for a safe, comfortable, and luxurious journey."
  },
  {
    "name": "13 seater Urbania van hire Pune",
    "description": "Hire a 13 seater Urbania van in Pune for weddings, corporate events, airport transfers, and group excursions. Fully AC-equipped with cushioned seating, ample luggage space, and reliable drivers for stress-free travel."
  },
  {
    "name": "13 seater Urbania rental Pune",
    "description": "13 seater Urbania rental in Pune for local and outstation travel. Perfect for family trips, corporate transport, sightseeing tours, and weekend getaways. Vehicles are maintained to the highest standard with luxury interiors and AC comfort."
  },
  {
    "name": "Urbania 13 seater hire in Pune",
    "description": "Urbania 13 seater hire in Pune providing premium group travel for city tours, airport transfers, corporate events, and family outings. Spacious interiors, air-conditioned comfort, smooth ride, and experienced drivers included."
  },
  {
    "name": "13 seater Force Urbania hire Pune",
    "description": "13 seater Force Urbania hire in Pune for corporate events, weddings, airport transfers, and group tours. Luxury interiors, cushioned seating, AC, ample luggage space, and professional drivers for a comfortable and reliable experience."
  },
  {
    "name": "Luxury 13 seater Urbania on rent Pune",
    "description": "Luxury 13 seater Urbania on rent in Pune for premium group travel, weddings, corporate trips, and family outings. Enjoy elegant interiors, fully AC-equipped vehicles, smooth rides, and experienced chauffeurs."
  },
  {
    "name": "AC 13 seater Urbania rental Pune",
    "description": "AC 13 seater Urbania rental in Pune for local and outstation travel. Perfect for corporate teams, families, and small groups traveling for weddings, events, airport transfers, or sightseeing tours with comfort and safety."
  },
  {
    "name": "Urbania 13 seater van booking Pune",
    "description": "Book a 13 seater Urbania van in Pune for corporate trips, family outings, airport transfers, and group excursions. Fully air-conditioned, spacious seating, luggage-friendly, and driven by experienced professionals."
  },
  {
    "name": "13 seater Urbania on rent near me Pune",
    "description": "Find 13 seater Urbania on rent near you in Pune for convenient and safe travel. Ideal for corporate travel, family trips, airport pickups, and outstation journeys with AC comfort and professional drivers."
  },
  {
    "name": "13 seater Urbania hire Pimpri Chinchwad",
    "description": "Hire 13 seater Urbania in Pimpri Chinchwad for city travel, airport transfers, weddings, corporate events, and weekend trips. Luxury interiors, cushioned seating, AC, and professional drivers ensure a smooth ride."
  },
  {
    "name": "13 seater Urbania rental Baner Pune",
    "description": "13 seater Urbania rental in Baner Pune for corporate, family, and group travel. Spacious, AC-equipped vehicles with experienced drivers provide safe and comfortable journeys within Pune and outstation."
  },
  {
    "name": "13 seater Urbania hire Hinjewadi Pune",
    "description": "13 seater Urbania hire in Hinjewadi Pune for IT companies, corporate transport, employee commutes, airport transfers, and group trips. Fully AC vehicles with professional drivers for reliable service."
  },
  {
    "name": "13 seater Urbania on rent Kharadi Pune",
    "description": "13 seater Urbania on rent in Kharadi Pune for corporate events, weddings, airport transfers, and family outings. Smooth, AC-equipped, spacious interiors with professional chauffeurs."
  },
  {
    "name": "13 seater Urbania on rent Pune for outstation",
    "description": "Book a 13 seater Urbania in Pune for outstation trips to Lonavala, Mahabaleshwar, Shirdi, Goa, and Mumbai. Luxury interiors, comfortable seating, AC, luggage space, and professional drivers ensure a hassle-free journey."
  },
  {
    "name": "13 seater Urbania on rent Pune for wedding",
    "description": "13 seater Urbania on rent in Pune for wedding transport. Elegant interiors, AC, spacious seating for family and guests, luggage space, and professional drivers make your wedding travel smooth and luxurious."
  },
  {
    "name": "13 seater Urbania corporate hire Pune",
    "description": "13 seater Urbania corporate hire in Pune for meetings, conferences, seminars, employee transportation, and client visits. Fully AC, spacious seating, and professional drivers ensure reliable corporate travel."
  },
  {
    "name": "13 seater Urbania for group travel Pune",
    "description": "13 seater Urbania for group travel in Pune. Perfect for corporate teams, friends, family outings, sightseeing tours, airport transfers, and outstation trips. Comfortable, AC-equipped, and driven by professional chauffeurs."
  },
  {
    "name": "13 seater Urbania for family trip Pune",
    "description": "13 seater Urbania for family trips in Pune offering spacious interiors, AC comfort, luggage space, smooth rides, and professional drivers for a safe and enjoyable journey."
  },
  {
    "name": "Pune to Lonavala 13 seater Urbania",
    "description": "Travel from Pune to Lonavala in a 13 seater Urbania with Amruta Travels. Enjoy scenic routes, luxury interiors, AC comfort, spacious seating, luggage space, and reliable drivers for a memorable trip."
  },
  {
    "name": "Pune to Mahabaleshwar 13 seater Urbania",
    "description": "Book 13 seater Urbania from Pune to Mahabaleshwar for comfortable hill station trips. Spacious interiors, AC, cushioned seating, luggage handling, and experienced drivers included."
  },
  {
    "name": "Pune to Shirdi 13 seater Urbania on rent",
    "description": "13 seater Urbania from Pune to Shirdi for darshan travel. Comfortable, AC-equipped interiors, spacious seating, and experienced drivers make your pilgrimage journey smooth and safe."
  },
  {
    "name": "Pune to Mumbai 13 seater Urbania hire",
    "description": "Travel from Pune to Mumbai in a 13 seater Urbania for comfortable, timely, and smooth long-distance trips. AC interiors, luggage space, cushioned seats, and professional drivers provided."
  },
  {
    "name": "Pune to Goa 13 seater Urbania rentals",
    "description": "13 seater Urbania from Pune to Goa for leisure and long-distance travel. Enjoy luxury interiors, air-conditioning, ample seating, luggage space, and reliable drivers for a comfortable journey."
  },
  {
    "name": "13 seater Urbania on rent Pune price",
    "description": "13 seater Urbania on rent in Pune at affordable and competitive rates for corporate travel, family outings, city tours, airport transfers, and outstation trips."
  },
  {
    "name": "13 seater Urbania Pune per km rate",
    "description": "13 seater Urbania rental in Pune with per km rates for city travel and outstation trips. Transparent pricing, AC comfort, spacious seating, and professional drivers ensure a smooth experience."
  },
  {
    "name": "Cheap 13 seater Urbania on rent Pune",
    "description": "Cheap 13 seater Urbania on rent in Pune offering economical rates without compromising on comfort, AC interiors, cushioned seating, and professional driver services for local or outstation trips."
  },
  {
    "name": "Best 13 seater Urbania rental Pune",
    "description": "Best 13 seater Urbania rental service in Pune for safe, comfortable, and luxurious group travel. Ideal for corporate events, family outings, weddings, airport transfers, and city sightseeing."
  },
  {
    "name": "13 seater Urbania rental packages Pune",
    "description": "13 seater Urbania rental packages in Pune for hourly, daily, weekend, and outstation trips. Perfect for weddings, corporate travel, family trips, and sightseeing tours with AC, cushioned seating, and professional drivers."
  },
  {
    "name": "Book 13 seater Urbania in Pune",
    "description": "Book 13 seater Urbania in Pune easily online for corporate, family, wedding, and outstation trips. Spacious, AC-equipped interiors with reliable drivers ensure a smooth and safe journey."
  },
  {
    "name": "Online booking 13 seater Urbania Pune",
    "description": "Online booking of 13 seater Urbania in Pune for hassle-free reservations. Ideal for corporate travel, weddings, family trips, and airport transfers with luxury interiors and experienced drivers."
  },
  {
    "name": "Hire 13 seater Urbania Pune today",
    "description": "Hire 13 seater Urbania in Pune today for immediate travel needs. AC interiors, spacious seating, luggage-friendly, and professional drivers ensure a comfortable and reliable experience."
  },
  {
    "name": "13 Seater Force Urbania On Rent in Pune",
    "description": "13 Seater Force Urbania on rent in Pune for corporate events, weddings, airport transfers, family outings, and city tours. Luxury interiors, AC comfort, cushioned seats, and experienced drivers."
  },
  {
    "name": "Luxury 13 Seater Urbania Hire Pune",
    "description": "Luxury 13 Seater Urbania hire in Pune for premium group travel. Fully AC, cushioned seating, spacious interiors, ample luggage space, smooth rides, and professional drivers for weddings, corporate trips, and family tours."
  }
],
"tableData": [
  ["13 Seater Urbania on rent in Pune", "Urbania 13 seater on rent Pune"],
  ["Force Urbania 13 seater on rent Pune", "13 seater Urbania van hire Pune"],
  ["13 seater Urbania rental Pune", "Urbania 13 seater hire in Pune"],
  ["13 seater Force Urbania hire Pune", "Luxury 13 seater Urbania on rent Pune"],
  ["AC 13 seater Urbania rental Pune", "Urbania 13 seater van booking Pune"],
  ["13 seater Urbania on rent near me Pune", "13 seater Urbania hire Pimpri Chinchwad"],
  ["13 seater Urbania rental Baner Pune", "13 seater Urbania hire Hinjewadi Pune"],
  ["13 seater Urbania on rent Kharadi Pune", "13 seater Urbania on rent Pune for outstation"],
  ["13 seater Urbania on rent Pune for wedding", "13 seater Urbania corporate hire Pune"],
  ["13 seater Urbania for group travel Pune", "13 seater Urbania for family trip Pune"],
  ["Pune to Lonavala 13 seater Urbania", "Pune to Mahabaleshwar 13 seater Urbania"],
  ["Pune to Shirdi 13 seater Urbania on rent", "Pune to Mumbai 13 seater Urbania hire"],
  ["Pune to Goa 13 seater Urbania rentals", "13 seater Urbania on rent Pune price"],
  ["13 seater Urbania Pune per km rate", "Cheap 13 seater Urbania on rent Pune"],
  ["Best 13 seater Urbania rental Pune", "13 seater Urbania rental packages Pune"],
  ["Book 13 seater Urbania in Pune", "Online booking 13 seater Urbania Pune"],
  ["Hire 13 seater Urbania Pune today", "13 Seater Force Urbania On Rent in Pune"],
  ["Luxury 13 Seater Urbania Hire Pune", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable 13 Seater Urbania for Group Travel",
    "WhyChoosedescription": "Amruta Travels offers 13 Seater Urbania On Rent in Pune, combining comfort, style, and practicality. Ideal for small to medium-sized groups, it ensures a smooth and premium travel experience."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Family, and VIP Trips",
    "WhyChoosedescription": "Whether it’s a corporate outing, family excursion, or VIP transport, renting a 13 Seater Urbania provides spacious, comfortable, and stylish travel across Pune and nearby regions."
  },
  {
    "WhyChooseheading": "Spacious and Well-Designed Interiors",
    "WhyChoosedescription": "The 13 Seater Urbania comes with plush seating, ample legroom, air conditioning, large windows, and generous luggage space, making it perfect for day trips, long journeys, or city tours."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Our trained drivers ensure a smooth, safe, and punctual journey. Experienced in handling the 13 Seater Urbania, they provide courteous and professional service for every trip."
  },
  {
    "WhyChooseheading": "Transparent Pricing and Affordable Luxury",
    "WhyChoosedescription": "Enjoy the luxury of the 13 Seater Urbania at competitive rates. Amruta Travels provides upfront pricing with no hidden charges, offering excellent value for group travel."
  },
  {
    "WhyChooseheading": "Well-Maintained and Hygienic Vehicles",
    "WhyChoosedescription": "All 13 Seater Urbania vehicles are regularly serviced and sanitized, ensuring the highest standards of safety, hygiene, and comfort for passengers."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Custom Routes",
    "WhyChoosedescription": "We provide flexible scheduling, customized travel routes, and multiple pickup/drop-off points to suit your itinerary for local or outstation trips."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking a 13 Seater Urbania On Rent in Pune is hassle-free with Amruta Travels. Our friendly support team assists you at every step, ensuring a seamless experience from start to finish."
  }
]

    }

const faqData = [
  {
    question: 'How can I rent a 13 Seater Urbania in Pune?',
    answer: 'Renting a 13 Seater Urbania in Pune is simple with Amruta Travels. You can book online, call our support team, or visit our office. We help you choose the ideal vehicle for your group and travel needs.'
  },
  {
    question: 'What are the key features of the 13 Seater Urbania?',
    answer: 'The 13 Seater Urbania features comfortable interiors, plush seating, air conditioning, large windows, ample luggage space, and modern amenities, ensuring a premium and comfortable travel experience.'
  },
  {
    question: 'Is the 13 Seater Urbania suitable for outstation trips?',
    answer: 'Yes, the 13 Seater Urbania is ideal for both local and outstation trips. It offers comfort, stability, and a smooth ride even for long-distance journeys.'
  },
  {
    question: 'Does the rental include a driver?',
    answer: 'Yes, every 13 Seater Urbania rental comes with a professional and courteous driver who ensures a safe, timely, and comfortable journey for all passengers.'
  },
  {
    question: 'Are the 13 Seater Urbania vehicles well-maintained?',
    answer: 'Absolutely. All our 13 Seater Urbania vehicles are regularly serviced, cleaned, and maintained to provide maximum safety, hygiene, and comfort.'
  },
  {
    question: 'What is the cost of renting a 13 Seater Urbania in Pune?',
    answer: 'The rental cost depends on trip duration, distance, and any additional services. Contact Amruta Travels for a customized, transparent quote.'
  },
  {
    question: 'Can I customize pickup and drop-off points?',
    answer: 'Yes, we provide flexible pickup and drop-off options and can customize the route according to your schedule and travel plan.'
  },
  {
    question: 'Why choose Amruta Travels for 13 Seater Urbania rental in Pune?',
    answer: 'Amruta Travels offers well-maintained 13 Seater Urbania vehicles, professional drivers, transparent pricing, and dedicated support, ensuring a premium and comfortable travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rohit Shinde',
    role: 'Corporate Manager, Pune',
    text: 'We rented a 13 Seater Urbania for a corporate outing. The vehicle was spacious, clean, and very comfortable. The driver was professional and punctual. Excellent service from Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Sneha Kulkarni',
    role: 'Event Planner, Pune',
    text: 'Booked a 13 Seater Urbania for a family trip. The bus was luxurious and very comfortable. The ride was smooth, and the driver was courteous. Highly recommend Amruta Travels!',
    rating: 5
  }
];















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const schemaData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "LocalBusiness",
      "name": "Amruta Travels",
      "image": "https://bushireinpune.com/assets/images/13-seater-urbania-on-rent-pune.jpg",
      "url": "https://bushireinpune.com/13-seater-urbania-on-rent-pune",
      "telephone": "+91 7353109555",
      "priceRange": "₹₹",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Pune",
        "addressRegion": "Maharashtra",
        "addressCountry": "IN"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "ratingCount": "6842"
      }
    },
    {
      "@type": "Service",
      "serviceType": "13 Seater Urbania Rental Pune",
      "provider": {
        "@type": "LocalBusiness",
        "name": "Amruta Travels"
      },
      "areaServed": {
        "@type": "City",
        "name": "Pune"
      },
      "description": "Book 13 seater Force Urbania on rent in Pune for family trips, corporate travel, airport transfer, weddings and outstation journeys."
    },
    {
      "@type": "Product",
      "name": "13 Seater Urbania On Rent in Pune",
      "image": "https://bushireinpune.com/assets/images/13-seater-urbania-on-rent-pune.jpg",
      "description": "Luxury 13 seater Urbania rental in Pune with AC, pushback seats, professional drivers and affordable per km pricing.",
      "brand": {
        "@type": "Brand",
        "name": "Amruta Travels"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "ratingCount": "6842"
      },
      "offers": {
        "@type": "Offer",
        "priceCurrency": "INR",
        "price": "6200",
        "availability": "https://schema.org/InStock",
        "url": "https://bushireinpune.com/13-seater-urbania-on-rent-pune"
      }
    },
    {
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is the price of 13 seater Urbania in Pune?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The price starts from ₹6200 and depends on distance, duration and trip type."
          }
        },
        {
          "@type": "Question",
          "name": "Is Urbania available for outstation trips?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Urbania is available for trips to Mumbai, Lonavala, Mahabaleshwar, Shirdi and Goa."
          }
        },
        {
          "@type": "Question",
          "name": "Can I book Urbania for airport transfer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, 13 seater Urbania is available for Pune and Mumbai airport transfers."
          }
        }
      ]
    }
  ]
};


    return (
        <div>

<Helmet>
  <title>
    13 Seater Urbania On Rent in Pune | Force Urbania Hire Pune | ₹6200 Starting | Call 7353109555
  </title>

  <meta
    name="description"
    content="Book 13 seater Urbania on rent in Pune at best price. Luxury Force Urbania van hire for family trips, corporate travel, weddings, airport transfer & Pune to Mumbai, Shirdi, Goa tours. Call now!"
  />

  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/102.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Onethreeurbaniaonrentinpune;